module.exports = __webpack_public_path__ + "img/align-right-02.509b7dd6.svg";